import { Box, SearchInput as MacawSearchInput } from "@saleor/macaw-ui-next";
import React from "react";

import { useNavigatorSearchContext } from "../../NavigatorSearch/useNavigatorSearchContext";

export const TopNavSearch = () => {
  const { setNavigatorVisibility } = useNavigatorSearchContext();

  const handleSearchClick = () => {
    setNavigatorVisibility(true);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      setNavigatorVisibility(true);
    }
  };

  return (
    <Box 
      display="flex" 
      alignItems="center" 
      width="100%"
    >
      <Box position="relative" width="100%">
        <MacawSearchInput
          placeholder="Search products, orders, customers..."
          size="medium"
          onClick={handleSearchClick}
          onKeyDown={handleKeyDown}
          readOnly
          value=""
          onChange={() => {}} // No-op since it's read-only
          style={{
            cursor: "pointer",
            width: "100%",
          }}
          data-test-id="global-search-input"
        />
        <Box
          position="absolute"
          right={3}
          __top="50%"
          __transform="translateY(-50%)"
          backgroundColor="default2"
          __borderRadius="4px"
          paddingX={1.5}
          paddingY={0.5}
          __fontSize="11px"
          __color="#6B7280"
          __pointerEvents="none"
          style={{ fontFamily: "monospace" }}
        >
          ⌘K
        </Box>
      </Box>
    </Box>
  );
};